import { t } from "@lingui/macro";
import {
  OutgoingInvoiceTypeEnum,
  RequestForInvoicingTypeEnum,
} from "@src/__generated__/urql-graphql";
import {
  BudgetSplits,
  InvoiceDetails,
  ProjectDetails,
} from "@src/components/modules/invoices/Create/components/Steps";
import type { FunctionComponent } from "react";

export enum InvoiceTypeEnum {
  Outgoing = "outgoing",
  Proforma = "proforma",
  CreditNote = "credit-note",
}

export const InvoiceTypeEnumFrom = (
  type: RequestForInvoicingTypeEnum | OutgoingInvoiceTypeEnum,
): InvoiceTypeEnum => {
  switch (type) {
    case OutgoingInvoiceTypeEnum.Invoice:
    case RequestForInvoicingTypeEnum.Invoice:
      return InvoiceTypeEnum.Outgoing;

    case OutgoingInvoiceTypeEnum.CreditNote:
    case RequestForInvoicingTypeEnum.CreditNote:
      return InvoiceTypeEnum.CreditNote;

    default:
      return InvoiceTypeEnum.Proforma;
  }
};

export const InvoiceTypeEnumToRfiEnum = (
  type: InvoiceTypeEnum | undefined,
): RequestForInvoicingTypeEnum => {
  switch (type) {
    case InvoiceTypeEnum.Proforma:
      return RequestForInvoicingTypeEnum.Proforma;

    case InvoiceTypeEnum.CreditNote:
      return RequestForInvoicingTypeEnum.CreditNote;

    case InvoiceTypeEnum.Outgoing:
    default:
      return RequestForInvoicingTypeEnum.Invoice;
  }
};

export interface InvoiceStep {
  id: InvoiceStepIds;
  label: string;
  content: FunctionComponent<any>;
}

export enum InvoiceStepIds {
  ProjectDetails = "project-details",
  BudgetItems = "budget-items",
  InvoiceDetails = "invoice-details",
}

export function getSteps(isCreditNote: boolean): InvoiceStep[] {
  const PROJECT_DETAIL_STEP: InvoiceStep = {
    id: InvoiceStepIds.ProjectDetails,
    label: t`Project details`,
    content: ProjectDetails,
  };

  const BUDGET_ITEMS_STEP: InvoiceStep = {
    id: InvoiceStepIds.BudgetItems,
    label: t`Budget items`,
    content: BudgetSplits,
  };

  const INVOICE_DETAILS_STEP: InvoiceStep = {
    id: InvoiceStepIds.InvoiceDetails,
    label: isCreditNote ? t`Credit note details` : t`Invoice details`,
    content: InvoiceDetails,
  };

  return [PROJECT_DETAIL_STEP, BUDGET_ITEMS_STEP, INVOICE_DETAILS_STEP];
}

export type InvoiceItemVatGroup = {
  vatPercent: number;
  vatPercentFormatted: string;
  vatAmount: number;
};
